import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { NUMBER, SCIENTIFIC, FIT, MTTF_HOURS, MTTF_YEARS } from "const"
import {
    StoreType,
    ChangeUserSettings,
    updateUserSettings,
} from "client/store"
import {
    FormGroup,
    Label,
    RadioButton,
    IncreaseInput,
    CheckboxWrapper,
} from "client/components"

import DecimalExample from "./decimalExample"


const FailureRate = () => {
    const settings = useSelector((state: StoreType) => state.userSettings.settings.sil)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const onChange = (value: ChangeUserSettings) => {
        dispatch(updateUserSettings("sil", value))
    }

    const {
        failureRate,
        failureRateDecimal,
    } = settings

    return (
        <Row>
            <Col xs={4}>
                <FormGroup>
                    <Label>{lang.failureRateFields}</Label>
                    <CheckboxWrapper displayColumn>
                        <RadioButton
                            checked={failureRate === NUMBER}
                            onChange={() => onChange({ failureRate: NUMBER })}
                            title={lang.number}
                        />
                        <RadioButton
                            checked={failureRate === SCIENTIFIC}
                            onChange={() => onChange({ failureRate: SCIENTIFIC })}
                            title={lang.scientific}
                        />
                        <RadioButton
                            checked={failureRate === FIT}
                            onChange={() => onChange({ failureRate: FIT })}
                            title={lang.fit}
                        />
                        <RadioButton
                            checked={failureRate === MTTF_HOURS || failureRate === MTTF_YEARS}
                            onChange={() => onChange({ failureRate: MTTF_HOURS })}
                            title={lang.mttf}
                        />
                        {
                            (failureRate === MTTF_HOURS || failureRate === MTTF_YEARS) && (
                                <CheckboxWrapper displayColumn style={{ paddingLeft: "26px", paddingBottom: "0" }}>
                                    <RadioButton
                                        checked={failureRate === MTTF_HOURS}
                                        onChange={() => onChange({ failureRate: MTTF_HOURS })}
                                        title={lang.hours}
                                    />
                                    <RadioButton
                                        checked={failureRate === MTTF_YEARS}
                                        onChange={() => onChange({ failureRate: MTTF_YEARS })}
                                        title={lang.years}
                                    />
                                </CheckboxWrapper>
                            )
                        }
                    </CheckboxWrapper>
                </FormGroup>
            </Col>
            <Col xs={8}>
                <FormGroup>
                    <Label>{lang.decimal}</Label>
                    <Row>
                        <Col xs={6}>
                            <IncreaseInput
                                onChange={(val) => onChange({ failureRateDecimal: val })}
                                value={failureRateDecimal}
                            />
                        </Col>
                        <Col xs={6}>
                            <DecimalExample format={failureRate} decimal={failureRateDecimal} />
                        </Col>
                    </Row>
                </FormGroup>
            </Col>
        </Row>
    )
}
export default FailureRate
